import Styled from 'styled-components'

const StyledUl = Styled.ul`
  list-style: square;
`

export default StyledUl


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/StyledOrderSummary.js